/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppUpdateCompositionsDetailMutationRequest, WebAppUpdateCompositionsDetailMutationResponse, WebAppUpdateCompositionsDetailPathParams, WebAppUpdateCompositionsDetail401, WebAppUpdateCompositionsDetail403 } from "../models/WebAppUpdateCompositionsDetail";

export function getWebAppUpdateCompositionsDetailUrl(id: WebAppUpdateCompositionsDetailPathParams["id"]) {
  const res = { method: 'PATCH', url: `/web-app/v1/compositions/${id}` as const }
  return res
}

/**
 * @summary Update a composition by id
 * {@link /web-app/v1/compositions/:id}
 */
export async function webAppUpdateCompositionsDetail(id: WebAppUpdateCompositionsDetailPathParams["id"], data: WebAppUpdateCompositionsDetailMutationRequest, config: Partial<RequestConfig<WebAppUpdateCompositionsDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppUpdateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppUpdateCompositionsDetail401 | WebAppUpdateCompositionsDetail403>, WebAppUpdateCompositionsDetailMutationRequest>({ method : "PATCH", url : getWebAppUpdateCompositionsDetailUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}